import { KnowledgeBaseView } from "./knowledge-base-view"
import "./knowledge-base.css"

export const KnowledgeBasePage = () => <KnowledgeBaseView />

export default KnowledgeBasePage
